<div class="dialog-container" [formGroup]="form">
  <!-- Header -->
  <div class="dialog-header">
    <div class="user-edit-icon">
      <!-- <i class="{{ details.image[0] }}" [style]="details.image[1]"></i> -->
      <img [src]="details.image" alt="{{details.title}}" class="device-img"/>
    </div>
    <div class="header-text">
      <h2 style="font-weight: 600;">Log {{ details.title }}</h2>
    </div>
    <img class="close-button" (click)="onCancel()" src="assets/images/close-circle.svg">
    <!-- <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button> -->
  </div>

  <!-- Form Content -->
  <form (ngSubmit)="onSubmit()" class="dialog-content" [formGroup]="form">
    <!-- Non-BP Fields -->
    <ng-container *ngIf="categoryType !== 'Blood Pressure'">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Reading ({{ valueUnit1 }})</mat-label>
         <input 
      matInput 
      type="number" 
      [placeholder]="'Enter ' + details?.title" 
      formControlName="value1"
      maxlength="3" 
      [min]="0"
      (input)="getChange('value1')" 
      (keypress)="preventNonNumeric($event)" 
      (paste)="preventPasteNonNumeric($event)" 
    />
        <!-- <mat-error *ngIf="form.controls.value1.invalid">Required</mat-error>
        <mat-error *ngIf="form.controls.value1.hasError('min')">Value must be greater than 10</mat-error>
        <mat-error *ngIf="form.controls.value1.hasError('max')">Value must be less than 999</mat-error> -->

        <!-- Required error -->
        <mat-error *ngIf="form.controls['value1'].hasError('required') ">This field is required</mat-error>
        <!-- Min value error -->
        <mat-error *ngIf="form.controls['value1'].hasError('min') ">Value must be greater than 10</mat-error>
        <!-- Max value error -->
        <mat-error *ngIf="form.controls['value1'].hasError('max')">Value must be less than 999</mat-error>

      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="categoryType=='Blood Glucose'">
      <h3>When did you check?</h3>
    <div class="meal-selection">
            <div
            *ngFor="let meal of mealTypes"
            class="meal-option"
            [class.selected]="selectedMeal === meal.key"
            (click)="selectMeal(meal)"
            >
            <img [src]="meal.icon" alt="{{ meal.label }}" width="32" height="32" />
            <div>{{ meal.label }}</div>
            </div>
        </div>
    </ng-container>
    

    <!-- Blood Pressure Fields -->
    <ng-container *ngIf="categoryType === 'Blood Pressure'">
      <div class="datetime-picker">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Systolic ({{ valueUnit1 }})</mat-label>
           <input 
        matInput 
        type="number" 
        placeholder="Enter Systolic" 
        formControlName="value1"
        maxlength="3"
        [min]="0"
        (input)="getChange('value1')" 
        (keypress)="preventNonNumeric($event)" 
        (paste)="preventPasteNonNumeric($event)" 
      />
          <!-- <mat-error *ngIf="form.controls.value1.invalid">Required</mat-error>
                 <mat-error *ngIf="form.controls.value1.hasError('min')">Value must be greater than 10</mat-error> -->
          <!-- Required error -->
          <mat-error *ngIf="form.controls['value1'].hasError('required') ">This field is required</mat-error>
          <!-- Min value error -->
          <mat-error *ngIf="form.controls['value1'].hasError('min')">Value must be greater than 10</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Diastolic ({{ valueUnit2 }})</mat-label>
          <input 
        matInput 
        type="number" 
        placeholder="Enter Diastolic" 
        formControlName="value2"
        maxlength="3"
        [min]="0"
        (input)="getChange('value2')" 
        (keypress)="preventNonNumeric($event)" 
        (paste)="preventPasteNonNumeric($event)" 
      />
          <!-- <mat-error *ngIf="form.controls.value2.invalid">Required</mat-error>
                <mat-error *ngIf="form.controls.value1.hasError('min')">Value must be greater than 10</mat-error> -->
          <!-- Required error -->
          <mat-error *ngIf="form.controls['value2'].hasError('required') ">This field is required</mat-error>
          <!-- Min value error -->
          <mat-error *ngIf="form.controls['value2'].hasError('min')">Value must be greater than 10</mat-error>
        </mat-form-field>
      </div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Pulse ({{ valueUnit3 }})</mat-label>
           <input 
      matInput 
      type="number" 
      placeholder="Enter Pulse" 
      formControlName="value3"
      maxlength="3"
      [min]="0"
      (input)="getChange('value3')" 
      (keypress)="preventNonNumeric($event)" 
      (paste)="preventPasteNonNumeric($event)" 
    />
          <!-- <mat-error *ngIf="form.controls.value3.invalid">Required</mat-error> -->
        
          <!-- Required error -->
          <mat-error *ngIf="form.controls['value3'].hasError('required') ">This field is required</mat-error>
          <!-- Min value error -->
          <mat-error *ngIf="form.controls['value3'].hasError('min')">Value must be greater than 10</mat-error>
          <!-- Max value error -->
          <mat-error *ngIf="form.controls['value3'].hasError('max')">Value must be less than 999</mat-error>
        
        </mat-form-field>
    </ng-container>

    <!-- Date/Time -->
    <div class="datetime-picker">
      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="readingDate" readonly (focus)="picker.open()" (click)="picker.open()" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="half-width">
      <mat-label>Time</mat-label>
      <div class="input-with-icon">
        <img src="assets/images/health/icons/Frame 1000004270.svg" class="clckicon" alt="Clock Icon" />
        <input
          type="time"
          matInput
          formControlName="readingTime" 
          [value]="form.controls.readingTime.value"
        />
      </div>
    </mat-form-field>

    </div>

    <!-- Comment -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Comment</mat-label>
      <textarea matInput formControlName="comment" placeholder="Write message here..."></textarea>
    </mat-form-field>

    <!-- Actions -->
    <div class="dialog-actions">
      <button mat-stroked-button color="primary" type="button" (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" type="submit">Save</button>
    </div>
  </form>
</div>
